import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import HighlightsBarLayout from './highlights-bar-layout';

class HighlightsBarComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        if (!this.options.endpointUrl) {
            throw new Error('Invalid endpoint URL');
        }

        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <HighlightsBarLayout options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default HighlightsBarComponent;
